export default function flattenMapping(nestedMapping: Record<string, unknown>, prefix = ""): Record<string, string> {
    const result: Record<string, string> = {}

    Object.entries(nestedMapping).forEach(([key, value]) => {
        const nestedKey = prefix ? `${prefix}.${key}` : key

        if (typeof value === "object" && value !== null) {
            // @ts-expect-error type mismatch
            Object.assign(result, flattenMapping(value, nestedKey))
        } else {
            // @ts-expect-error type mismatch
            result[nestedKey] = value
        }
    })

    return result
}
